var AssistCisitWaitDistribution = function () { return import('~/pages/assist-manage/assist-visit-wait-distribution.vue'); };
var AssistVisitTeamCollection = function () { return import('~/pages/assist-manage/assist-visit-team-collection.vue'); };
var AssistVisitCollection = function () { return import('~/pages/assist-manage/assist-visit-collection.vue'); };
var AssistTelWaitDistribution = function () { return import('~/pages/assist-manage/assist-tel-wait-distribution.vue'); };
var AssistTelCollection = function () { return import('~/pages/assist-manage/assist-tel-collection.vue'); };
var AssistTelTeamCollection = function () { return import('~/pages/assist-manage/assist-tel-team-collection.vue'); };
var AssistLegalWaitDistribution = function () { return import('~/pages/assist-manage/assist-legal-wait-distribution.vue'); };
var AssistLegalCollection = function () { return import('~/pages/assist-manage/assist-legal-collection.vue'); };
var AssistLegalTeamCollection = function () { return import('~/pages/assist-manage/assist-legal-team-collection.vue'); };
// const AssistVisitStay = () => import('~/pages/assist-manage/assist-visit-stay.vue');
// const AssistCase = () => import('~/pages/assist-manage/assist-case.vue');
// const AssistAntiFraudSurveyCase = () => import('~/pages/assist-manage/assist-anti-fraud-survey-case.vue');
// const AssistAntiFraudCaseStay = () => import('~/pages/assist-manage/assist-anti-fraud-case-stay.vue');
export default [
    {
        path: '/assist-manage/assist-tel-wait-distribution',
        name: 'assist-tel-wait-distribution',
        component: AssistTelWaitDistribution,
    },
    {
        path: '/assist-manage/assist-tel-collection',
        name: 'assist-tel-collection',
        component: AssistTelCollection,
    },
    {
        path: '/assist-manage/assist-tel-team-collection',
        name: 'assist-tel-team-collection',
        component: AssistTelTeamCollection,
    },
    {
        path: '/assist-manage/assist-visit-wait-distribution',
        name: 'assist-visit-wait-distribution',
        component: AssistCisitWaitDistribution,
    },
    {
        path: '/assist-manage/assist-visit-collection',
        name: 'assist-visit-collection',
        component: AssistVisitCollection,
    },
    {
        path: '/assist-manage/assist-visit-team-collection',
        name: 'assist-visit-team-collection',
        component: AssistVisitTeamCollection,
    },
    {
        path: '/assist-manage/assist-legal-wait-distribution',
        name: 'assist-legal-wait-distribution',
        component: AssistLegalWaitDistribution,
    },
    {
        path: '/assist-manage/assist-legal-collection',
        name: 'assist-legal-collection',
        component: AssistLegalCollection,
    },
    {
        path: '/assist-manage/assist-legal-team-collection',
        name: 'assist-legal-team-collection',
        component: AssistLegalTeamCollection,
    },
];
